import React from "react";
import styled from "styled-components/macro";
import { colors } from "theme/Theme";
import { InnerBodyType } from "../multisplitOptions/types";
import MultisplitOptionsTableRow from "components/multisplitOptionTableRow";
import { device, TabletUp } from "theme/Breakpoints";

interface Props {
  items: InnerBodyType[];
}

export enum BodyTypeToTitle {
  стенен = "Стенни",
  таванен = "Таванни",
  подов = "Подови",
}

const MultisplitOptionTable: React.FC<Props> = ({ items }) => {
  return (
    <TableContainer>
      <TableHeader>
        <span className="text-body">{BodyTypeToTitle[items[0].type]}</span>
      </TableHeader>
      <TabletUp>
        <TableSubHeader>
          <div className="subheader-item text-xs">Снимка</div>
          <div className="subheader-item text-xs">Модел</div>
          <div className="subheader-item text-xs">Цена</div>
        </TableSubHeader>
      </TabletUp>
      <InnerBodyRows>
        {items.map((innerBody: InnerBodyType, idx: number) => {
          return <MultisplitOptionsTableRow key={idx} item={innerBody} />;
        })}
      </InnerBodyRows>
    </TableContainer>
  );
};

const TableContainer = styled.div`
  background-color: ${colors.gray};
  padding-bottom: 20px;
`;

const TableHeader = styled.div`
  background-color: black;
  text-align: center;
  padding: 10px 0;

  span {
    color: white;
    font-weight: 600;
  }
`;

const TableSubHeader = styled.div`
  display: flex;
  flex-flow: row nowrap;
  padding: 5px 10px;

  @media only screen and (${device.tablet}) {
    .subheader-item:first-child {
      flex: 0 0 280px;
    }
  }

  @media only screen and (${device.laptop}) {
    padding: 5px 20px;
    .subheader-item:first-child {
      flex: 0 0 320px;
    }
  }

  @media only screen and (${device.laptopL}) {
    .subheader-item:first-child {
      flex: 0 0 420px;
    }
  }

  .subheader-item {
    flex: 1;
    justify-self: flex-start;
    color: ${colors.dark_gray};
    font-weight: 600;
  }
`;

const InnerBodyRows = styled.div`
  margin: 10px;

  @media only screen and (${device.laptop}) {
    margin: 20px;
  }
`;

export default MultisplitOptionTable;
